// extracted by mini-css-extract-plugin
export default {"rescan-instructions":"RescanInstructions_rescan-instructions__0liOo","rescan__header":"RescanInstructions_rescan__header__J6HQl"};